import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  container: {
    position: "absolute",
    top: 0,
    width: "100%",
  },
});
